import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const TrainingLibraryRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "TrainingLibrary" */ 'modules/trainingLibrary/TrainingLibrary/pages/TrainingLibrary'
    )
)

const TrainingLibraryRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={TrainingLibraryRoute} />
      <Redirect path='*' to={routes.root} />
    </Switch>
  </Suspense>
)

export default TrainingLibraryRouting
